import { XHR } from "./polling-xhr.node.js";
import { WS } from "./websocket.node.js";
import { WT } from "./webtransport.js";
export const transports = {
  websocket: WS,
  webtransport: WT,
  polling: XHR
};